import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {environment} from '../../../../environments/environment';
import {HttpService} from '../../../services/http.service';

@Component({
  selector: 'app-filter-from-file-dialog',
  templateUrl: './filter-from-file-dialog.component.html',
  styleUrls: ['./filter-from-file-dialog.component.scss']
})
export class FilterFromFileDialogComponent implements OnInit {
  private file: File | undefined;

  public environment: string;
  constructor(
    private httpService: HttpService,
    private dialogRef: MatDialogRef<FilterFromFileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    if (data.environment === 'delete') {
      this.environment = 'delete';
    } else {
      this.environment = data.environment === 'Staging' ? 'stage' : 'production';
    }
  }

  ngOnInit(): void {
  }

  public uploadFile(event: any): void {
    this.file = event.target.files[0];
    if (this.file) {
      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('environment', this.environment);

      this.httpService.post(environment.API_PATH + '/filter', formData).subscribe((res: any) => {
        this.dialogRef.close();
      });
    }
  }
}
